import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { ConstantsProviders } from '../providers/constants/constants';
import { catchError, filter, map, timeout } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class HeaderConfigInterceptor implements HttpInterceptor {
  user: any;
  private readonly requestTimeout = 25000; // 25 seconds
  constructor(
    private authService: MsalService,
    private constants: ConstantsProviders,
    private router: Router
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!request.url.includes(this.constants.apiHost)) {
      return next.handle(request);
    }
    if (
      !request.url.includes('tasks/attachment') &&
      !request.url.includes('upload-file') &&
      !request.headers.has('Content-Type') &&
      !request.headers.has('X-Custom-Headers')
    ) {
      request = request.clone({
        headers: request.headers.set('Content-Type', 'application/json'),
      });
    }
    return next.handle(request).pipe(
      filter(
        (event) =>
          event instanceof HttpResponse &&
          request.url.includes(this.constants.apiHost)
      ),
      timeout(this.requestTimeout),
      map((event: HttpResponse<any>) => {
        return event.clone({ body: event.body.data });
      }),
      catchError((error: any) => {
        // todo remover el any e identificar correctamente el tipo de error
        let errorMessage: string;
        if ('error' in error) {
          if ('message' in error.error) {
            errorMessage = '' + error.error.message;
          }
        } else if (error.error instanceof ErrorEvent) {
          errorMessage = `Error: ${error.error.message}`;
        } else {
          console.log('Error is ', error);
          errorMessage = `Error Code: ${error.status},  Message: ${error.message}`;
        }
        if (error.status === 401 || error.status === 403) {
          throwError(errorMessage);
          localStorage.clear();
          this.router.navigate(['/']);
        }
        return throwError(errorMessage);
      })
    );
  }
}
